import React from "react";
import { ButtonGroup, Dropdown } from "react-bootstrap";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import { useI18n } from "../../lib/i18n/i18n_provider";

import { Icon } from "../../components";
import { Option } from "react-select/src/filters";
import { useAnalytics } from "../../lib/analytics/analytics";

interface CityPickerProps {
  cities: Option[];
  value?: string;
  onChange: (city: string) => void;
}

export function CityPicker(props: CityPickerProps) {
  const { fbt } = useI18n();
  const { value, cities, onChange } = props;
  const analytics = useAnalytics();

  return (
    <div className="checkout-box-picker-view">
      <Dropdown
        as={ButtonGroup}
        className="checkout-box-picker row"
        id={`city-picker`}
        size="lg"
        onSelect={(value: any) => {
          onChange(value);

          analytics.event(
            "City Select Click",
            {
              City: value,
              Source: "WL",
            },
            { onlyProviders: ["mixpanel", "customerio"] }
          );
        }}
      >
        <Dropdown.Toggle>
          <div data-testid="city-picker" className="row">
            <div className="col-10 checkout-box-picker-placeholder">
              <span className="row fw-bold text-uppercase checkout-box-picker-placeholder__label">
                {fbt("City")}
              </span>
              <span className="row checkout-box-picker-selected">
                {value ? (
                  value
                ) : (
                  <span className="fw-lighter checkout-box-picker-selected__placeholder">
                    {fbt("Select a city")}
                  </span>
                )}
              </span>
            </div>
            <div className="checkout-box-picker-icon">
              <Icon name="fi-chevron-down" size={24} />
            </div>
          </div>
        </Dropdown.Toggle>
        <DropdownMenu
          popperConfig={{
            modifiers: [
              {
                name: "preventOverflow",
                options: {
                  altAxis: true,
                },
              },
            ],
          }}
        >
          <Dropdown.Header className="text">
            <div className="dropdown-header">
              <span className="row fw-bold text-uppercase">
                {fbt("Select a city")}
              </span>
            </div>
          </Dropdown.Header>
          <div className="overflow-auto" style={{ maxHeight: 200 }}>
            {cities.map((opt, index) => (
              <>
                <Dropdown.Item
                  as="button"
                  eventKey={opt.value}
                  active={opt.value === value}
                >
                  {opt.label}
                </Dropdown.Item>
                {index !== cities.length - 1 && <Dropdown.Divider />}
              </>
            ))}
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

interface OptionSelector {
  value: string;
  label: string;
  soldOut?: boolean;
}

interface MembershipCityPickerProps {
  cities: OptionSelector[];
  value?: string;
  onChange: (city: string) => void;
}

export function MembershipCityPicker(props: MembershipCityPickerProps) {
  const { fbt } = useI18n();
  const { value, cities, onChange } = props;
  const analytics = useAnalytics();
  const selectedOption = cities.find((opt) => opt.label === value);

  return (
    <div className="checkout-box-picker-view">
      <Dropdown
        as={ButtonGroup}
        className="checkout-box-picker row"
        id={`city-picker`}
        size="lg"
        onSelect={(value: any) => {
          onChange(value);

          analytics.event(
            "City Select Click",
            {
              City: value,
              Source: "WL",
            },
            { onlyProviders: ["mixpanel", "customerio"] }
          );
        }}
      >
        <Dropdown.Toggle>
          <div className="row">
            <div className="col-10 checkout-box-picker-placeholder">
              <span className="row fw-bold text-uppercase checkout-box-picker-placeholder__label">
                {fbt("City")}
              </span>
              <span className="row checkout-box-picker-selected">
                {value ? (
                  <span style={{ textAlign: "left" }} className="p-0">
                    <span className="p-0">{value}</span>
                    {selectedOption?.soldOut ? (
                      <span className="p-0">
                        <span className="p-0"> -</span>
                        <span className="p-0 text-danger">
                          {" "}
                          {fbt("Sold out")}
                        </span>
                      </span>
                    ) : (
                      ""
                    )}
                  </span>
                ) : (
                  <span className="fw-lighter checkout-box-picker-selected__placeholder">
                    {fbt("Select a city")}
                  </span>
                )}
              </span>
            </div>
            <div className="checkout-box-picker-icon">
              <Icon name="fi-chevron-down" size={24} />
            </div>
          </div>
        </Dropdown.Toggle>
        <DropdownMenu>
          <Dropdown.Header className="text">
            <div className="dropdown-header">
              <span className="row fw-bold text-uppercase">
                {fbt("Select a city")}
              </span>
            </div>
          </Dropdown.Header>
          <div className="overflow-auto" style={{ maxHeight: 200 }}>
            {cities.map((opt, index) => (
              <>
                <Dropdown.Item
                  as="button"
                  eventKey={opt.value}
                  active={opt.value === value}
                  disabled={opt.soldOut}
                >
                  <span style={{ textAlign: "left" }} className="p-0">
                    {opt.label}
                    {opt.soldOut ? (
                      <>
                        <span> -</span>
                        <span className="p-0 text-danger">
                          {" "}
                          {fbt("Sold out")}
                        </span>
                      </>
                    ) : (
                      ""
                    )}
                  </span>
                </Dropdown.Item>
                {index !== cities.length - 1 && <Dropdown.Divider />}
              </>
            ))}
          </div>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}
